module.exports = __webpack_public_path__ + "static/media/bg-light.cf1f869e.jpg";